import React from "react";
import PtiHistoryTab from "../../pti/components/PtiHistoryTab";

interface TrailerPtiHistoryTabProps {
    trailerId: number;
}

const TrailerPtiHistoryTab: React.FC<TrailerPtiHistoryTabProps> = ({ trailerId }) => (
    <PtiHistoryTab assetType="Trailer" assetId={trailerId} />
);

export default TrailerPtiHistoryTab;
